module.exports = __webpack_public_path__ + "static/media/event-services-img16.4dda6113.jpg";